import lf from 'lovefield'

export function simu_mouvements (schemaBuilder) {
  schemaBuilder.createTable('simu_mouvements')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('simu_etudes_id', lf.Type.INTEGER)
      .addColumn('exo_mouvements_id', lf.Type.INTEGER)
      .addColumn('debut', lf.Type.DATE_TIME)
      .addColumn('fin', lf.Type.DATE_TIME)
      .addColumn('valide', lf.Type.INTEGER)
      .addColumn('commence', lf.Type.INTEGER)
      .addPrimaryKey(['id'], true)
      .addNullable(['debut', 'fin', 'valide', 'commence']);
      // .addIndex('simuEtudes_id', ['simuEtudes_id']);

}

/*
CREATE TABLE IF NOT EXISTS `simu-mouvements` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `simu-etudes_id` int(11) NOT NULL,
  `exo-mouvements_id` int(11) NOT NULL,
  `debut` date NOT NULL,
  `fin` date NOT NULL,
  PRIMARY KEY (`id`),
  KEY `simu-etudes_id` (`simu-etudes_id`,`exo-mouvements_id`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8 AUTO_INCREMENT=1 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/simuMouvements.schema.js